export  const openDialog = (args) => {
  args.cancel = true;
};